export default {
    data: {
        general: {
            showLabels: true,
            labelType: 'draggable',
            showTrails: true,
            clusterLabels: true
        },
        runways: {
            arrival: [],
            departure: []
        },
        session: {
            active: 60000,
            medium: 120000,
            low: 180000,
            disconnected: 190000,
            fallbackTimeout: 15000
        },
        map: {
            activeSource: 'default',
            previewSource: null,
            sources: {
                osm: {
                    type: 'osm',
                    name: 'OpenStreetMap',
                    internal: true
                },
                esri: {
                    type: 'xyz',
                    name: 'Satellite',
                    url: 'https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                    internal: true,
                    view: {
                        maxZoom: 19
                    }
                }
            }
        },
        zones: {
            durations: [3, 5, 8, 12]
        },
        debug: {
            showBothSources: false,
            keepDisconnected: false,
            tisPlayer: true
        }
    },
    status: {
        fetched: false,
        isLoading: false,
        error: false
    }
};